export default __webpack_public_path__ + "static/media/search-empty.06fe8a3b.svg";